import { ClientResponseError } from 'pocketbase'
import { ErrorCode as ErrorCodeEnum } from '../src/types'
import type { ErrorCode } from '../src/types'

export type PocketBaseErrorShape = {
  code: ErrorCode
  message: string
  statusCode?: number
}

export function mapPocketBaseError(error: unknown): PocketBaseErrorShape {
  if (error instanceof ClientResponseError) {
    if (error.status === 401 || error.status === 403) {
      return {
        code: ErrorCodeEnum.AUTH_ERROR,
        message: 'Authentication failed',
        statusCode: error.status,
      }
    }

    if (error.status === 404) {
      return {
        code: ErrorCodeEnum.NOT_FOUND,
        message: 'Record not found',
        statusCode: error.status,
      }
    }

    if (error.status === 409) {
      return {
        code: ErrorCodeEnum.CONFLICT,
        message: 'Conflict error',
        statusCode: error.status,
      }
    }

    if (error.status >= 500) {
      return {
        code: ErrorCodeEnum.SERVER_ERROR,
        message: `Server error: ${error.status}`,
        statusCode: error.status,
      }
    }

    if (error.status >= 400) {
      return {
        code: ErrorCodeEnum.VALIDATION_ERROR,
        message: error.message || 'Validation error',
        statusCode: error.status,
      }
    }
  }

  if (error instanceof TypeError || (error instanceof Error && error.message.includes('Failed to fetch'))) {
    return {
      code: ErrorCodeEnum.NETWORK_ERROR,
      message: 'Network error',
    }
  }

  return {
    code: ErrorCodeEnum.UNKNOWN_ERROR,
    message: error instanceof Error ? error.message : 'Unknown error',
  }
}
